module.exports = __webpack_public_path__ + "static/automatic-ai-4733fe4dd3ea6777c50501d82d07fbf3.png";